/**
 * 网站底部
 */
<template>
    <div class="login-bottom">
        版权所有：Copyright © {{ record_company }}
    </div>
</template>
<script>
    import { getIPCConfig } from '../api/evalMG'
    export default {
        name: 'bottomNav',
        data() {
            return {
             record_company: '',
             record_icp: ''
            }
        },
        created() {
            this.getIPCConfigData()
        },
        methods: {
            // 查询ICP信息
            getIPCConfigData(){
            getIPCConfig()
            .then((res=>{
                if(res.code == 200){
                    this.record_company = res.data.record_company,
                    this.record_icp = res.data.record_icp
                }
            }))
            },
        }
    }
</script>
<style scoped>
  .login-bottom {
    width: 100%;
    position: absolute;
    bottom: 40px;
    font-size: 12px;
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/bottomNav.vue